import React from 'react';
import {
  ArticleContent,
  ArticleMainImage,
  ArticleTitle,
  BreadCrumbs,
  ContentAndSidebar,
  PostMainContent,
  ShareButton,
  Slideshow as SlideshowComponent,
  Sponsor,
} from 'mm-ui-components';
import { HeaderPostSidebarConnected } from '../../components/connectedComponents/PostSidebarConnected';
import { createDefaultBlocksWidths } from '../postPage.util';
import {
  ArticleComponentDataProps,
  FiniteScrollArticleComponentDataProps,
  MainArticleComponentDataProps,
} from '../utils/articleComponent.utils';
import {
  useFiniteScrollBrowserURLManagerRegistration,
} from '../../components/finiteScroll/FiniteScrollBrowserURLManager';
import { DisclaimersAtDynamicPosition } from '../../components/disclaimer/DisclaimersAtDynamicPosition';

const defaultBlocksWidths = createDefaultBlocksWidths();

export const BaliArticleComponent: React.FunctionComponent<ArticleComponentDataProps> = props => {
  const {
    title,
    intro,
    by,
    createdAt,
    createdAtISO,
    updatedAt,
    updatedAtISO,
    showUpdatedAt,
    authors,
    shareConfig,
    cover,
    siteName,
    templateName,
    sponsor,
    slideshow,
    body,
    sideBar1Id,
    sideBar2Id,
    sideBar1AdOnSuccess,
    sideBar2AdOnSuccess,
    mainArticleURL,
    disclaimerText,
    shouldDisplayDisclaimerAtBottom,
    breadCrumbs,
    commercialTags,
    shouldShowHeroImage = true,
    ownerUsername,
    resourceID,
    isMobileViewer,
  } = props;
  const { experiments, canonical, addMMPlayerPlaceholder = false } = props as MainArticleComponentDataProps;
  const { articleUrl } = props as FiniteScrollArticleComponentDataProps;
  const url = mainArticleURL || canonical || articleUrl;
  const ref = useFiniteScrollBrowserURLManagerRegistration(url as string, title);
  const breadCrumbsMarginFactor = {
    largeMarginFactor: 1,
    mediumMarginFactor: 1,
    smallMarginFactor: 1,
  };
  return (
    <div ref={ref}>
      <ContentAndSidebar>
        <PostMainContent>
          <header>
            <ArticleTitle
              title={title}
              by={by}
              createdAt={createdAt}
              createdAtISO={createdAtISO}
              updatedAt={updatedAt}
              updatedAtISO={updatedAtISO}
              showUpdatedAt={showUpdatedAt}
              authors={authors}
              intro={intro}
            >
              <ShareButton shareConfig={shareConfig} canonical={url} />
            </ArticleTitle>
            {shouldShowHeroImage && (
              <ArticleMainImage
                {...cover}
                siteName={siteName}
                templateName={templateName}
                defaultBlocksWidths={defaultBlocksWidths}
              />
            )}
          </header>
          {sponsor ? <Sponsor {...sponsor} /> : null}
          <main>
            <SlideshowComponent {...slideshow} blockWidths={defaultBlocksWidths} experiments={experiments} commercialTags={commercialTags} ownerUsername={ownerUsername} resourceID={resourceID}>
              <DisclaimersAtDynamicPosition
                disclaimerText={disclaimerText}
                defaultBlocksWidths={defaultBlocksWidths}
                shouldDisplayDisclaimerAtBottom={shouldDisplayDisclaimerAtBottom}
              >
                <ArticleContent
                  body={body}
                  templateName={templateName}
                  siteName={siteName}
                  defaultBlocksWidths={defaultBlocksWidths}
                  addMMPlayerPlaceholder={addMMPlayerPlaceholder}
                  totalSlides={slideshow.totalSlides}
                  experiments={experiments}
                  commercialTags={commercialTags}
                  ownerUsername={ownerUsername}
                  isMobileViewer={isMobileViewer}
                />
              </DisclaimersAtDynamicPosition>
            </SlideshowComponent>
            {breadCrumbs ? (
              <BreadCrumbs
                {...breadCrumbs}
                marginFactor={breadCrumbsMarginFactor}
                isBottom
              />
            ) : null}
          </main>
        </PostMainContent>
        <HeaderPostSidebarConnected
          adId1={sideBar1Id}
          adId2={sideBar2Id}
          adOnSuccess2={sideBar2AdOnSuccess}
          adOnSuccess1={sideBar1AdOnSuccess}
        />
        <div id="bottom-placeholder" />
      </ContentAndSidebar>
    </div>
  );
};
